import { styled } from "@mui/material/styles";

export const RegistrationFlowContainer = styled("div")(({ theme }) => ({
  position: "relative",
  maxWidth: "1440px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: theme.space._1000,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: theme.space._700,
  padding: `0 ${theme.space._900}`,

  "@media (max-width: 900px)": {
    flexDirection: "column",
    alignItems: "center",
    padding: `0 ${theme.space._400}`,
  },
}));

export const RegistrationStepContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const SessionPanelContainer = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "5rem",
  height: "min-content",
  maxWidth: theme.space._1300,
  borderRadius: "1rem",
  overflow: "hidden",
  background: theme.colors["neutral.900"],
  zIndex: 0,

  "@media (max-width: 900px)": {
    display: "none",
  },
}));

export const SessionPanelContent = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  zIndex: 1,
}));
